// extracted by mini-css-extract-plugin
export var deliveryRow = "_h6-a";
export var fixedHeight = "_h6-4";
export var freightLogo = "_h6-9";
export var fullWidth = "_h6-3";
export var priceColumn = "_h6-5";
export var radioSelected = "_h6-7";
export var radioUnselected = "_h6-6";
export var selectedOption = "_h6-2";
export var selectedOptionContainer = "_h6-1";
export var selection = "_h6-0";
export var tallSkeletonText = "_h6-8";